import React, { useState, useEffect, useRef } from 'react';
import imageList from '../pictures.json';

const MockupSlider = () => {
  const [mockups, setMockups] = useState(imageList.map(url => ({ mockup_image_url: url })));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const timeoutRef = useRef(null);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    if (!isPaused) {
      timeoutRef.current = setTimeout(
        () =>
          setCurrentIndex((prevIndex) =>
            prevIndex === mockups.length - 1 ? 0 : prevIndex + 1
          ),
        3000
      );
    }

    return () => {
      resetTimeout();
    };
  }, [currentIndex, mockups.length, isPaused]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % mockups.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + mockups.length) % mockups.length);
  };

  if (mockups.length === 0) {
    return <div>Loading mockups...</div>;
  }

  return (
    <div 
      className="relative w-full max-w-lg mx-auto" 
      onMouseEnter={() => setIsPaused(true)} 
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="overflow-hidden rounded-lg shadow-lg">
        <img src={mockups[currentIndex].mockup_image_url} alt={`Mockup ${currentIndex + 1}`} className="w-full" />
      </div>
      <button onClick={prevSlide} className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full">
        &#10094;
      </button>
      <button onClick={nextSlide} className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full">
        &#10095;
      </button>
    </div>
  );
};

export default MockupSlider;
